import React, { useState } from "react";
import VehicleRegistration from "./VehicleRegistration";
import { nanoid } from "nanoid";

export default function VehicleMake(props) {
  const [mainRegistration, setRegistration] = useState({
    registration: "",
  });
  const carMakeOptions = window.$makes.map((item) => {
    return <option key={nanoid()}>{item}</option>;
  });
  const carColorOptions = window.$colors.map((item) => {
    return <option key={nanoid()}>{item}</option>;
  });
  const carYearOptions = window.$years.map((item) => {
    return <option key={nanoid()}>{item}</option>;
  });
  function handleRegistration(event) {
    event.preventDefault();
    setRegistration({
      registration: event.target.value,
    });
  }
  function handleSubmitToParent(event) {
    event.preventDefault();
    props.handleRegistration(event, props.index);
  }
  console.log(mainRegistration.registration);
  return (
    <div className="vehicle_info">
      <div className="VehicleMake">
        <label htmlFor="vehicle_makes">Vehicle Make</label>
        <select
          id="vehicle_makes"
          name="vehicle_makes"
          value={props.make}
          placeholder="Select Car Make"
          onChange={(event) => props.handleMake(event, props.index)}
        >
          <option key={nanoid()} disabled={true} value="">
            Select Car Make
          </option>
          {carMakeOptions}
        </select>
        <label htmlFor="vehicle_models">Vehicle Model</label>
        <select
          id="vehicle_models"
          name="vehicle_models"
          value={props.model}
          onChange={(event) => props.handleModel(event, props.index)}
        >
          <option key={nanoid()} disabled={true} value="">
            Select Car Model
          </option>
          {props.models.map((item) => {
            return <option key={nanoid()}>{item.label}</option>;
          })}
        </select>
        <label htmlFor="vehicle_year">Vehicle Year</label>
        <select
          id="vehicle_year"
          name="vehicle_year"
          value={props.year}
          onChange={(event) => props.handleYear(event, props.index)}
        >
          <option key={nanoid()} disabled={true} value="">
            Select Year
          </option>
          {carYearOptions.map((item) => {
            return <option key={nanoid()}>{item}</option>;
          })}
        </select>
        <label htmlFor="vehicle_color">Vehicle Color</label>
        <select
          id="vehicle_color"
          name="vehicle_color"
          value={props.color}
          onChange={(event) => props.handleColor(event, props.index)}
        >
          <option key={nanoid()} disabled={true} value="">
            Select Color
          </option>
          {carColorOptions.map((item) => {
            return <option key={nanoid()}>{item}</option>;
          })}
        </select>

        <label>Vehicle Registration</label>
        <input
          type="text"
          value={
            props.registration.length > 0
              ? props.registration
              : mainRegistration.registration
          }
          onBlur={(event) => handleSubmitToParent(event)}
          onChange={(event) => handleRegistration(event)}
        ></input>
        <label className="checkBox">
          My vehicle model is not in the list:
          <input
            name="isGoing"
            type="checkbox"
            checked={props.checkbox}
            onChange={(event) => props.handleCheckBox(event, props.index)}
          />
        </label>
      </div>
      <div className="vehicle_container">
        <div className="remove_vehicle">
          <button
            className="remove_text"
            onClick={(event) => props.removeVehicle(event, props.index)}
          >
            X
          </button>
        </div>
      </div>
    </div>
  );
}
